import C5UsuarioLoginModel from "./C5UsuarioLoginModel";

class UsuarioLoginModel {
  email: string = "";
  senha: string = "";
  facebookId: string = "";
  googleId: string = "";
  clientId: number = 0;

  public static toModel(obj: UsuarioLoginModel): C5UsuarioLoginModel {
    return {
      Email: obj.email,
      Password: obj.senha,
      FacebookID: obj.facebookId,
      GoogleID: obj.googleId,
    }
  }
}

export default UsuarioLoginModel;